// Only override what shared/js/dialog.js didn’t already set

// default settings
$.ui.dialog.prototype.options.classes = {'ui-dialog': 'scs-pageheader-ui-dialog'};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/dialog.js
// module id = 108
// module chunks = 0